import { $ as e, A as t, C as n, F as r, L as i, S as a, U as o, _ as ee, at as s, g as te, h as c, i as l, k as ne, m as u, ot as d, p as f, q as p, t as m, v as h, w as g, z as re } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as ie, t as _ } from "./i18n-lite-BcmwMblk.js";
import { t as v } from "./normalize-props-DNjMoRjC.js";
import { t as y } from "./Button.ce-Dstoud2U.js";
import { t as ae } from "./shadow-dom-9FbsLIC0.js";
import { t as oe } from "./Popin.ce-aq5qU85Q.js";
//#region src/webcomponents/pix-combinaisons/locales/de-AT.json
var b = {}, x = {}, S = {}, C = {}, w = {}, T = { "pix-combinaisons": {
	findCombinations: "Trouvez les combinaisons",
	discoverCombinations: "Combinaisons découvertes",
	progression: "Progression",
	validate: "Valider",
	ariaValidate: "Valider la combinaison",
	displayAllCombinations: "Voir toutes les combinaisons",
	combinationAlreadyTried: "Vous avez déjà essayé cette combinaison",
	fourPasswords: "4 mots de passe sont possibles. C’est peu !",
	easilyTestable: "Une personne peut facilement tester toutes les combinaisons\xA0à la main.",
	next: "Suivant",
	soManyPasswords: "27 mots de passe sont possibles !",
	feedbackSoManyPasswords: "Environ 7 fois plus de combinaisons qu’avant. Ça augmente vite dis donc ! 😱\u2028Quand on\xA0ajoute des caractères\xA0et qu’on\xA0allonge le mot de passe, il faut\xA0beaucoup plus de temps\xA0pour tout tester à la main.",
	completed: "Terminé",
	backspace: "Retour en arrière",
	currentStep: "{{step}} {{number}}",
	step: "Étape",
	numberOfChars: "{{number}}\xA0caractères",
	completionState: "Vous avez trouvé {{percent}} des combinaisons possibles"
} }, E = {}, D = {}, O = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.8333%209.16675H4.16667C3.24619%209.16675%202.5%209.91294%202.5%2010.8334V16.6667C2.5%2017.5872%203.24619%2018.3334%204.16667%2018.3334H15.8333C16.7538%2018.3334%2017.5%2017.5872%2017.5%2016.6667V10.8334C17.5%209.91294%2016.7538%209.16675%2015.8333%209.16675Z'%20stroke='%235E6C84'%20stroke-width='1.66667'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5.83331%209.16675V5.83341C5.83331%204.72835%206.2723%203.66854%207.0537%202.88714C7.8351%202.10573%208.89491%201.66675%209.99998%201.66675C11.105%201.66675%2012.1649%202.10573%2012.9463%202.88714C13.7277%203.66854%2014.1666%204.72835%2014.1666%205.83341V9.16675'%20stroke='%235E6C84'%20stroke-width='1.66667'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", se = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M9.83713%207.37459C10.522%206.70686%2011.4406%206.33317%2012.3971%206.33325H26.1265C26.9238%206.33325%2027.8518%206.55459%2028.6105%207.02525C29.3825%207.50259%2030.0905%208.32392%2030.0905%209.49992V22.4999C30.0905%2023.6759%2029.3825%2024.4959%2028.6105%2024.9746C27.8597%2025.4244%2027.0016%2025.6635%2026.1265%2025.6666H12.3971C11.4406%2025.6667%2010.522%2025.293%209.83713%2024.6253L2.70379%2017.6706C2.48084%2017.4532%202.30365%2017.1934%202.18267%2016.9065C2.06169%2016.6195%201.99936%2016.3113%201.99936%2015.9999C1.99936%2015.6885%202.06169%2015.3803%202.18267%2015.0934C2.30365%2014.8064%202.48084%2014.5466%202.70379%2014.3293L9.83713%207.37459ZM18.7065%2012.6266C18.6149%2012.5283%2018.5045%2012.4495%2018.3818%2012.3949C18.2592%2012.3402%2018.1268%2012.3108%2017.9925%2012.3085C17.8582%2012.3061%2017.7248%2012.3308%2017.6003%2012.3811C17.4758%2012.4314%2017.3627%2012.5062%2017.2677%2012.6012C17.1728%2012.6962%2017.0979%2012.8093%2017.0476%2012.9338C16.9973%2013.0583%2016.9726%2013.1917%2016.975%2013.3259C16.9774%2013.4602%2017.0068%2013.5926%2017.0614%2013.7153C17.1161%2013.838%2017.1949%2013.9484%2017.2931%2014.0399L19.2531%2015.9999L17.2931%2017.9599C17.1949%2018.0515%2017.1161%2018.1619%2017.0614%2018.2845C17.0068%2018.4072%2016.9774%2018.5396%2016.975%2018.6739C16.9726%2018.8082%2016.9973%2018.9415%2017.0476%2019.066C17.0979%2019.1906%2017.1728%2019.3037%2017.2677%2019.3986C17.3627%2019.4936%2017.4758%2019.5685%2017.6003%2019.6187C17.7248%2019.669%2017.8582%2019.6937%2017.9925%2019.6914C18.1268%2019.689%2018.2592%2019.6596%2018.3818%2019.605C18.5045%2019.5503%2018.6149%2019.4715%2018.7065%2019.3733L20.6665%2017.4133L22.6265%2019.3733C22.718%2019.4715%2022.8284%2019.5503%2022.9511%2019.605C23.0737%2019.6596%2023.2062%2019.689%2023.3404%2019.6914C23.4747%2019.6937%2023.6081%2019.669%2023.7326%2019.6187C23.8571%2019.5685%2023.9702%2019.4936%2024.0652%2019.3986C24.1601%2019.3037%2024.235%2019.1906%2024.2853%2019.066C24.3356%2018.9415%2024.3603%2018.8082%2024.3579%2018.6739C24.3555%2018.5396%2024.3262%2018.4072%2024.2715%2018.2845C24.2168%2018.1619%2024.138%2018.0515%2024.0398%2017.9599L22.0798%2015.9999L24.0398%2014.0399C24.138%2013.9484%2024.2168%2013.838%2024.2715%2013.7153C24.3262%2013.5926%2024.3555%2013.4602%2024.3579%2013.3259C24.3603%2013.1917%2024.3356%2013.0583%2024.2853%2012.9338C24.235%2012.8093%2024.1601%2012.6962%2024.0652%2012.6012C23.9702%2012.5062%2023.8571%2012.4314%2023.7326%2012.3811C23.6081%2012.3308%2023.4747%2012.3061%2023.3404%2012.3085C23.2062%2012.3108%2023.0737%2012.3402%2022.9511%2012.3949C22.8284%2012.4495%2022.718%2012.5283%2022.6265%2012.6266L20.6665%2014.5866L18.7065%2012.6266Z'%20fill='%232C75FF'/%3e%3c/svg%3e", k = { class: "stepper" }, A = ["aria-hidden"], j = { class: "character-value" }, M = { class: "sr-only" }, N = { class: "character-info" }, P = ["aria-hidden"], F = { class: "character-value" }, I = { class: "sr-only" }, L = { class: "character-info" }, R = { class: "cards" }, z = { class: "card card-left" }, B = ["aria-level"], V = ["src"], H = {
	class: "sr-only",
	"aria-live": "polite"
}, U = {
	id: "letters",
	class: "placeholders",
	"aria-live": "polite"
}, W = { class: "letters-and-back" }, ce = ["src"], G = {
	key: 0,
	class: "doublon-feedback",
	"aria-live": "polite"
}, le = { class: "card card-right" }, ue = ["aria-level"], de = ["src"], fe = ["aria-live"], K = /*#__PURE__*/ m(/* @__PURE__ */ g({
	__name: "PixCombinaisons.ce",
	props: {
		wontWait: {
			type: Boolean,
			default: !1
		},
		titleLevel: {
			default: 2,
			type: Number
		}
	},
	setup(l, { expose: m }) {
		ae();
		let { t: g } = ie(), _ = o("combination"), v = o("wrapper"), b = e([]), x = e(!1), S = e([]), C = e(1), w = e(!1), T = e(!1), E = u(() => b.value.length === Y.value.length || q.value), D = u(() => b.value.length === 0 || q.value), K = u(() => b.value.length !== Y.value.length && !q.value || T.value), q = u(() => S.value.length >= 7), J = [["A", "B"], [
			"A",
			"B",
			"C"
		]], Y = u(() => J[C.value - 1]), pe = u(() => S.value.length === Z.value.length && !w.value), me = u(() => C.value === 1 ? {
			title: g("pix-combinaisons.fourPasswords"),
			content: g("pix-combinaisons.easilyTestable"),
			textButton: g("pix-combinaisons.next")
		} : {
			title: g("pix-combinaisons.soManyPasswords"),
			content: g("pix-combinaisons.feedbackSoManyPasswords"),
			textButton: g("pix-combinaisons.completed")
		}), he = u(() => q.value ? g("pix-combinaisons.displayAllCombinations") : g("pix-combinaisons.validate")), ge = u(() => q.value ? g("pix-combinaisons.displayAllCombinations") : g("pix-combinaisons.ariaValidate")), X = u(() => `${(S.value.length * 100 / Z.value.length).toFixed(0)}%`), _e = u(() => `${C.value === 1 ? "50" : "100"}%`), Z = u(() => $(Y.value));
		function Q() {
			b.value = [], x.value = !1, S.value = [], C.value = 1, w.value = !1, T.value = !1;
		}
		function $(e, t = e) {
			let n = [];
			for (let r = 0; r < e.length; r++) for (let i = 0; i < t.length; i++) n.push(`${e[r]}${t[i]}`);
			return n[0].length === t.length ? n : $(n, e);
		}
		async function ve() {
			if (C.value === 2) {
				w.value = !0;
				return;
			}
			b.value = [], x.value = !1, S.value = [], await t(), v.value.focus(), C.value = 2;
		}
		function ye(e) {
			b.value.push(e);
		}
		async function be() {
			if (q.value) {
				T.value = !0;
				let e = Z.value.filter((e) => !S.value.includes(e));
				for (let t of e) S.value.push(t), _.value.at(-1).scrollIntoView({
					block: "end",
					behavior: "smooth"
				}), l.wontWait || await new Promise((e) => setTimeout(e, 200));
				return;
			}
			let e = b.value.join("");
			if (xe(S.value, e)) {
				x.value = !0, b.value = [];
				return;
			}
			S.value.push(e), b.value = [], x.value = !1;
		}
		function xe(e, t) {
			return e.includes(t);
		}
		return m({ reset: Q }), (e, t) => {
			let o = re("i18n");
			return r(), h("div", {
				ref_key: "wrapper",
				ref: v,
				class: "wrapper",
				tabindex: "-1"
			}, [
				c("div", k, [
					c("div", {
						class: "character",
						"aria-hidden": C.value !== 1
					}, [c("p", j, [n(o, { t: "pix-combinaisons.currentStep" }, {
						step: p(() => [c("span", M, d(e.$t("pix-combinaisons.step")), 1)]),
						number: p(() => [...t[1] ||= [a(" 1 ", -1)]]),
						_: 1
					})]), c("p", N, [a(d(e.$t("pix-combinaisons.numberOfChars", { number: 2 })), 1), c("span", null, "(" + d(J[0].join(",")) + ")", 1)])], 8, A),
					c("div", {
						class: "stepper-bar",
						style: s({ "--step-progression": _e.value })
					}, null, 4),
					c("div", {
						class: "character",
						"aria-hidden": C.value !== 2
					}, [c("p", F, [n(o, { t: "pix-combinaisons.currentStep" }, {
						step: p(() => [c("span", I, d(e.$t("pix-combinaisons.step")), 1)]),
						number: p(() => [...t[2] ||= [a(" 2 ", -1)]]),
						_: 1
					})]), c("p", L, [a(d(e.$t("pix-combinaisons.numberOfChars", { number: 3 })), 1), c("span", null, "(" + d(J[1].join(",")) + ")", 1)])], 8, P)
				]),
				c("div", R, [c("section", z, [
					c("div", {
						id: "title",
						role: "heading",
						"aria-level": l.titleLevel + 1
					}, [c("img", {
						alt: "",
						src: O
					}, null, 8, V), a(" " + d(e.$t("pix-combinaisons.findCombinations")), 1)], 8, B),
					c("p", null, d(e.$t("pix-combinaisons.progression")), 1),
					c("div", {
						class: "progress-bar",
						style: s({ "--completion": X.value })
					}, null, 4),
					c("p", H, d(e.$t("pix-combinaisons.completionState", { percent: X.value })), 1),
					c("div", U, [(r(!0), h(f, null, i(Y.value.length, (e, t) => (r(), h("p", {
						key: e,
						class: "placeholder"
					}, d(b.value[t]), 1))), 128))]),
					c("div", W, [(r(!0), h(f, null, i(Y.value, (e) => (r(), te(y, {
						key: e,
						"is-disabled": E.value,
						class: "letter",
						"aria-controls": "letters",
						onClick: (t) => ye(e)
					}, {
						default: p(() => [a(d(e), 1)]),
						_: 2
					}, 1032, ["is-disabled", "onClick"]))), 128)), n(y, {
						"is-disabled": D.value,
						class: "backspace",
						"aria-label": e.$t("pix-combinaisons.backspace"),
						onClick: t[0] ||= (e) => b.value.pop()
					}, {
						default: p(() => [c("img", {
							src: se,
							alt: ""
						}, null, 8, ce)]),
						_: 1
					}, 8, ["is-disabled", "aria-label"])]),
					n(y, {
						class: "validate",
						"is-disabled": K.value,
						"aria-label": ge.value,
						"aria-describedby": "letters",
						onClick: be
					}, {
						default: p(() => [a(d(he.value), 1)]),
						_: 1
					}, 8, ["is-disabled", "aria-label"]),
					x.value ? (r(), h("p", G, d(e.$t("pix-combinaisons.combinationAlreadyTried")), 1)) : ee("", !0)
				]), c("section", le, [c("div", {
					role: "heading",
					"aria-level": l.titleLevel + 1
				}, [c("img", {
					alt: "",
					src: O
				}, null, 8, de), a(" " + d(e.$t("pix-combinaisons.discoverCombinations")), 1)], 8, ue), c("ul", {
					class: "results",
					"aria-live": T.value ? "polite" : "off"
				}, [(r(!0), h(f, null, i(S.value, (e) => (r(), h("li", {
					ref_for: !0,
					ref: "combination",
					key: e
				}, d(e), 1))), 128))], 8, fe)])]),
				n(oe, ne(me.value, {
					show: pe.value,
					onPrimaryAction: ve
				}), null, 16, ["show"])
			], 512);
		};
	}
}), [["styles", ["html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video,dialog{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}*{box-sizing:border-box;color:#122647;font-family:Nunito,Roboto,sans-serif}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}.doublon-feedback{background:#eaf1ff;border-radius:8px;padding:8px}.wrapper{padding:24px 0;position:relative}.stepper{align-items:center;gap:8px;width:60%;margin:0 auto calc(28px + 1.5rem);display:flex}.stepper .stepper-bar{background:#cdd1d9;border-radius:4px;width:100%;height:4px;position:relative}.stepper .stepper-bar:after{content:\"\";border-radius:inherit;width:var(--step-progression);background:#155dfc;height:100%;position:absolute}.stepper .character{aspect-ratio:1;background-color:#3d68ff;border-radius:50%;justify-content:center;align-items:center;width:32px;font-size:.875rem;font-weight:700;display:flex;position:relative}.stepper .character-value{color:#fff}.stepper .character-info{color:#3d68ff;text-align:center;width:fit-content;line-height:.75rem;position:absolute;top:100%;left:50%;transform:translate(-50%)}.stepper .character-info span{color:inherit;font-size:.75rem;display:block}.cards{flex-wrap:wrap;justify-content:center;gap:24px;display:flex}.card{background:#fff;border-radius:24px;width:100%;max-width:356px;padding:24px;box-shadow:0 2px 5px #4a3aff40,inset 0 -2px 5px #4a3aff26,inset 0 1px 1px #ffffff1a,inset 0 3px 4px #dfeeff1a}.card p{margin-block:8px;font-family:Roboto,sans-serif;font-size:.875rem}.card-left .progress-bar{background:#cdd1d9;border-radius:12px;height:12px;margin-bottom:24px;position:relative}.card-left .progress-bar:after{content:\"\";height:100%;width:var(--completion);background:linear-gradient(90deg,#2b7fff 0%,#00b8db 100%);border-radius:12px;position:absolute;left:0}.card-left .placeholders{justify-content:center;gap:8px;display:flex}.card-left .placeholder{text-align:center;background:#f4f5f7;border:2px dashed #cdd1d9;border-radius:10px;justify-content:center;align-items:center;width:64px;height:80px;font-size:1.25rem;font-weight:700;display:flex}.card-left .letters-and-back{cursor:pointer;justify-content:center;gap:8px;margin:16px 0;display:flex}.card-left .letter{color:#fff;text-align:center;background:#155dfc;border-radius:10px;padding-block:16px;font-size:1.25rem;font-weight:700}.card-left .letter:hover{background:#155dfcdd}.card-left .letter[aria-disabled=true]{background:#155dfc50}.card-left .backspace,.card-left .backspace:hover,.card-left .backspace[aria-disabled=true]{background:#f4f5f7}.card-left .backspace[aria-disabled=true] img{opacity:.5}.card-left .validate{width:100%;margin-bottom:24px;font-size:1rem;font-weight:700}.card-right{flex-direction:column;display:flex}.results{grid-template-columns:repeat(3,1fr);gap:8px;max-height:300px;display:grid;overflow-y:auto}.results li{text-align:center;background:#eaf1ff;border:2px solid #2c75ff;border-radius:10px;padding:15px 0;font-weight:700;list-style:none}div[role=heading]{align-items:center;gap:8px;margin-bottom:24px;font-size:1.25rem;font-weight:700;display:flex}button{cursor:pointer;border:none;border-radius:10px;flex:1}"]]]);
//#endregion
//#region src/webcomponents/pix-combinaisons/pix-combinaisons.ce.js
_.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": b,
	"./locales/en.json": x,
	"./locales/es-419.json": S,
	"./locales/es.json": C,
	"./locales/fr-BE.json": w,
	"./locales/fr.json": T,
	"./locales/it.json": E,
	"./locales/nl.json": D
}));
var q = l(K, { configureApp(e) {
	_.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(_);
} });
q.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: v(e.titleLevel)
}), window.customElements.define("pix-combinaisons", q);
//#endregion
